// Get mouse coordinates
const getMousePos = (e: MouseEvent) => {
  return {
    x: e.clientX,
    y: e.clientY
  }
}

// Linear interpolation
const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b

export { getMousePos, lerp }
